import React from 'react';
import InfoTooltip from '../../../common/tooltip/info';
import i18next from 'i18next';

const ApproveButton = (open, isCancelRequest) => {
  const info = isCancelRequest ? 'approveCancellationRequest' : 'approveTravelExpense';

  return (
    <InfoTooltip info={i18next.t(info)}>
      <button className="btn btn-xs btn-fill btn-success" onClick={open}>
        <i className="fa fa-check" />
      </button>
    </InfoTooltip>
  );
};

export default ApproveButton;



// WEBPACK FOOTER //
// ./src/components/actions/approve/button/index.js